<div class="qr-container">
  @if (invitedCenter(); as center) {
    <div class="qr-invite">
      @if (center.image) {
        <img class="qr-invite__logo" [src]="center.image" alt="" />
      } @else {
        <div class="qr-invite__logo qr-invite__logo--ph"><ion-icon name="business-outline"></ion-icon></div>
      }
      <div class="qr-invite__text">
        <span class="qr-invite__label">Convite de</span>
        <strong class="qr-invite__name">{{ center.name }}</strong>
      </div>
    </div>
  }

  @if (inviteError()) {
    <div class="qr-invite-error">
      <ion-icon name="alert-circle-outline"></ion-icon>
      <span>Convite inválido ou expirado. Você pode se cadastrar normalmente abaixo.</span>
    </div>
  }

  @if (isAthlete(); as isAthlete) {
    <div class="qr-header">
      <p class="qr-header__subtitle">
        @if (invitedCenter()) {
          Crie sua conta e torne-se aluno de {{ invitedCenter()?.name }}.
        } @else {
          {{ 'QUICK_USER.MESSAGE_INFO' | translate }}
        }
      </p>
    </div>
  }

  @if (!!form) {
    <form [formGroup]="form" class="qr-form">
      <!-- Nome -->
      <div class="qr-form__field">
        <label class="qr-form__label">{{ 'QUICK_USER.FULLNAME' | translate }}</label>
        <ion-input
          fill="solid"
          formControlName="fullName"
          data-test="qr-fullname"
          class="qr-input"
          [placeholder]="'QUICK_USER.FULLNAME_PLACEHOLDER' | translate"
          [errorText]="form.get('fullName')?.invalid && form.get('fullName')?.touched ? ('QUICK_USER.FULL_NAME_REQUIRED' | translate) : ''">
        </ion-input>
      </div>

      <!-- Telefone: seletor de país + máscara nacional (padrão @libs/phone-input) -->
      <div class="qr-form__field">
        <label class="qr-form__label">{{ 'QUICK_USER.PHONE' | translate }}</label>
        <lib-phone-input formControlName="cellphone" fill="solid" data-test="qr-cellphone"></lib-phone-input>
        @if (form.get('cellphone')?.invalid && form.get('cellphone')?.touched) {
          <ion-note color="danger" class="qr-form__phone-error">
            {{ (form.get('cellphone')?.errors?.['invalidPhone'] ? 'QUICK_USER.PHONE_INVALID_FORMAT' : 'QUICK_USER.PHONE_REQUIRED') | translate }}
          </ion-note>
        }
      </div>

      <!-- CPF / Documento estrangeiro (passaporte) -->
      <div class="qr-form__field">
        <label class="qr-form__label">{{ (foreignDocument() ? 'QUICK_USER.PASSPORT' : 'QUICK_USER.REGISTRATION_NUMBER') | translate }}</label>
        @if (!foreignDocument()) {
          <ion-input
            id="cpf-input"
            fill="solid"
            formControlName="cpf"
            data-test="qr-cpf"
            maxlength="14"
            type="text"
            inputmode="numeric"
            class="qr-input"
            [maskito]="cpfMaskitoOptions"
            [maskitoElement]="cpfPredicate"
            [placeholder]="'QUICK_USER.CPF_PLACEHOLDER' | translate"
            [errorText]="form.get('cpf')?.invalid && form.get('cpf')?.touched ? (isCPFInvalid() ? ('QUICK_USER.CPF_MUST_BE_VALID' | translate) : ('QUICK_USER.CPF_REQUIRED' | translate)) : ''">
          </ion-input>
        } @else {
          <!-- Sem maskito: passaporte é alfanumérico livre (5–50). -->
          <ion-input
            fill="solid"
            formControlName="cpf"
            data-test="qr-passport"
            maxlength="50"
            type="text"
            class="qr-input"
            [placeholder]="'QUICK_USER.PASSPORT_PLACEHOLDER' | translate"
            [errorText]="form.get('cpf')?.invalid && form.get('cpf')?.touched ? ('QUICK_USER.PASSPORT_INVALID' | translate) : ''">
          </ion-input>
        }
        <ion-checkbox
          class="qr-form__foreign-toggle"
          data-test="qr-foreign-doc"
          [checked]="foreignDocument()"
          (ionChange)="toggleForeignDocument($any($event).detail.checked)"
          labelPlacement="end">
          {{ 'QUICK_USER.NO_CPF_TOGGLE' | translate }}
        </ion-checkbox>
      </div>

      <!-- Email -->
      <div class="qr-form__field">
        <label class="qr-form__label">{{ 'QUICK_USER.EMAIL' | translate }}</label>
        <ion-input
          fill="solid"
          formControlName="email"
          data-test="qr-email"
          type="email"
          autocomplete="email"
          class="qr-input"
          [placeholder]="'QUICK_USER.EMAIL_PLACEHOLDER' | translate"
          (ionChange)="onEmailChange()"
          [errorText]="form.get('email')?.invalid && form.get('email')?.touched ? ('QUICK_USER.EMAIL_REQUIRED' | translate) : ''">
        </ion-input>
        @if (isLoading() === true) {
          <div class="qr-form__loading">
            <ion-spinner name="dots" color="primary"></ion-spinner>
          </div>
        }
        @if (isEmailInValid() === true && form.get('email')?.touched) {
          <ion-note color="danger" class="qr-form__email-error">
            {{ 'QUICK_USER.EMAIL_EXIST' | translate }}
          </ion-note>
          <button type="button" class="qr-form__login-cta" (click)="goToLogin()">
            Já tenho conta — entrar
          </button>
        }
      </div>

      <!-- Data de Nascimento -->
      <div class="qr-form__field">
        <label class="qr-form__label">{{ 'QUICK_USER.BIRTH_DATE' | translate }}</label>
        <ion-input
          fill="solid"
          formControlName="birthDate"
          data-test="qr-birthdate"
          type="date"
          class="qr-input">
        </ion-input>
      </div>

      <!-- Senha (athletes only) -->
      @if (isAthlete()) {
        <div class="qr-form__field">
          <label class="qr-form__label">{{ 'QUICK_USER.PASSWORD' | translate }}</label>
          <ion-input
            fill="solid"
            [type]="showPassword() ? 'text' : 'password'"
            formControlName="password"
            data-test="qr-password"
            class="qr-input"
            [placeholder]="'QUICK_USER.PASSWORD_PLACEHOLDER' | translate"
            [errorText]="form.get('password')?.invalid && form.get('password')?.touched ? (form.get('password')?.errors?.['required'] ? ('QUICK_USER.PASSWORD_REQUIRED' | translate) : ('QUICK_USER.PASSWORD_MIN_LENGTH' | translate)) : ''">
            <ion-button
              fill="clear"
              slot="end"
              class="qr-form__toggle-pw"
              (click)="togglePasswordVisibility()"
              type="button">
              <ion-icon
                slot="icon-only"
                [name]="showPassword() ? 'eye' : 'eye-off'"
                color="medium">
              </ion-icon>
            </ion-button>
          </ion-input>
        </div>

        <div class="qr-form__remember">
          <ion-checkbox
            [checked]="savePassword()"
            (ionChange)="savePassword.set($any($event).detail.checked)"
            labelPlacement="end">
            {{ 'QUICK_USER.REMEMBER_PASSWORD' | translate }}
          </ion-checkbox>
        </div>
      } @else {
        <div class="qr-form__info-banner">
          <ion-icon name="mail-outline" color="primary"></ion-icon>
          <span>{{ 'QUICK_USER.PASSWORD_SENT_EMAIL' | translate }}</span>
        </div>
      }

      <!-- Termos de Uso e Politica de Privacidade -->
      @if (isAthlete()) {
        @if (loadingTerms()) {
          <div class="qr-form__loading">
            <ion-spinner name="dots"></ion-spinner>
          </div>
        } @else if (hasTerms()) {
          <div class="qr-terms">
            <div class="qr-terms__header" (click)="toggleTerms()">
              <div class="qr-terms__header-left">
                <ion-icon name="shield-checkmark-outline" color="primary"></ion-icon>
                <strong>{{ 'QUICK_USER.ACCEPT_TERMS_TITLE' | translate }}</strong>
              </div>
              <ion-icon
                [name]="termsExpanded() ? 'chevron-up-outline' : 'chevron-down-outline'"
                color="medium">
              </ion-icon>
            </div>
            @if (termsExpanded()) {
              <div class="qr-terms__content">
                @for (term of terms(); track term.id) {
                  <div class="qr-terms__item">
                    <strong>{{ term.title }}</strong>
                    <div class="qr-terms__text" [innerHTML]="term.content"></div>
                  </div>
                }
              </div>
            }
            <div class="qr-terms__checkbox-wrapper">
              <ion-checkbox
                class="qr-terms__checkbox"
                data-test="qr-accept-terms"
                [checked]="acceptedTerms()"
                (ionChange)="acceptedTerms.set($any($event).detail.checked)"
                labelPlacement="end">
                {{ 'QUICK_USER.ACCEPT_TERMS' | translate }}
              </ion-checkbox>
            </div>
          </div>
        }
      }

      <!-- Register Button -->
      <!-- Habilitado por default; só desabilita enquanto envia (anti duplo-clique).
           As validações (campos, e-mail já existente, termos) acontecem no clique
           em registerUser(), com mensagem clara — nunca um botão travado sem motivo. -->
      <ion-button
        class="qr-form__submit"
        data-test="qr-submit"
        [disabled]="isLoading() === true"
        color="primary"
        expand="block"
        (click)="registerUser()">
        <span>{{ 'QUICK_USER.REGISTER' | translate }}</span>
        @if (isLoading() === true) {
          <ion-spinner name="crescent" class="qr-form__spinner"></ion-spinner>
        }
      </ion-button>
    </form>
  }
</div>
